import {Dictionary} from '@/types'

export function resolve(obj: Dictionary, key: string): any {
    const path = key.split('.')
    let value = obj[path[0]]
    for (let i = 1; i < path.length; i++) {
        value = value[path[i]]
    }
    return value
}

export function prop(type: any, defaultValue: any) {
    return {
        type,
        default: () => defaultValue
    }
}

export function parseToDate(s: string): Date | null {
    s = normalizeDate(s)

    const millis = Date.parse(s)
    if (Number.isNaN(millis)) {
        return null
    }

    return new Date(millis)
}

export function dateFormat(d: Date | string, pattern: string): string {
    const date: Date | null = typeof d === 'string'
        ? parseToDate(d)
        : d

    if (!date) {
        return ''
    }

    const format = (v: any) => (v || '').toString().padStart(2, '0')

    return pattern.replace(/([YmdHisu])/g, ((key) => {
        switch (key) {
            case 'Y':
                return date.getFullYear()

            case 'm':
                return format(date.getMonth() + 1)

            case 'd':
                return format(date.getDate())

            case 'H':
                return format(date.getHours())

            case 'i':
                return format(date.getMinutes())

            case 's':
                return format(date.getSeconds())

            case 'u':
                return date.getMilliseconds()

            default:
                throw new Error(`Invalid key: ${key}`)
        }
    }))
}

export function currency(amount: number): string {
    const options = {
        style: 'currency',
        currency: 'BRL'
    }
    return amount.toLocaleString('pt-BR', options).replace('R$', '').trim()
}

function isDate(str: string) {
    return (/^\d{4}-\d{2}-\d{2}$/).test(str)
}

function normalizeDate(date: string): string {
    date = date
        .replace(/([TZ]|\.\d+)/g, ' ')
        .trim()

    return isDate(date) ? `${date} 00:00:00` : date
}


export function document(s: any) {
    s = numbers(s)

    const reg = /^(((\d{3})(\d{3})(\d{3})(\d{2}))|((\d{2})(\d{3})(\d{3})(\d{4})(\d{2})))$/
    const res = reg.exec(s)
    if (!res) {
        return ''
    }
    if (res[2]) {
        return `${res[3]}.${res[4]}.${res[5]}-${res[6]}`
    }
    if (res[7]) {
        return `${res[8]}.${res[9]}.${res[10]}/${res[11]}-${res[12]}`
    }
    return ''
}

export function numbers(s: any) {
    if (!s) {
        return ''
    }

    return s.replace(/[^\d]/g, '')
}
